import * as Mod1 from "./discourse/api-initializers/discourse-auto-lock-pms";
import * as Mod2 from "./discourse/connectors/composer-fields/toggle-prevent-reply.gjs";
const compatModules = {
  "discourse/api-initializers/discourse-auto-lock-pms": Mod1,
  "discourse/connectors/composer-fields/toggle-prevent-reply": Mod2,
};
export { compatModules };
export default compatModules;
